import { render, staticRenderFns } from "./NewTransferErrorDetails.vue?vue&type=template&id=910f0bb0"
import script from "./NewTransferErrorDetails.vue?vue&type=script&lang=js"
export * from "./NewTransferErrorDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports